import http from "../../http";

const orderCenter = {
    selectOrderTenantPage(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderTenantPage", r)
    },
    selectOrderCompanyPage(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderCompanyPage", r)
    },
    getOperatorOrderCount(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/getOperatorOrderCount", r)
    },
    selectOrderOperatorPage(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderOperatorPage", r)
    },
    selectOrderCompanyList(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderCompanyList", r)
    },
    selectOrderCompanyStats(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderCompanyStats", r)
    },
    selectOrderCompanyPointStats(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderCompanyPointStats", r)
    },
    selectOrderCenterInfoByNo(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectOrderCenterInfoByNo", r)
    },
    getShippingCancelEnums(r) {
        return http.get("/gateway/api/sycompany/pc/ShippingOrderPC/getShippingCancelEnums", r)
    },
    shippingPreOrderCenter(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/shippingPreOrderCenter", r)
    },
    shippingOrderCenter(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/OrderCenterPC/shippingOrderCenter", r)
    },
    shippingOrderCenterCancel(r) {
        return http.payload("/gateway/api/sycompany/pc/OrderCenterPC/shippingOrderCenterCancel", r)
    },
    selectByOrderCenterMergeNo(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectByOrderCenterMergeNo", r)
    },
    cancelOrder(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/OrderCenterPC/cancelOrder", r)
    },
    selectMergeTenantPage(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/selectMergeTenantPage", r)
    },
    selectRefundTenantPage(r) {
        return http.get("/gateway/api/sycompany/pc/orderCenterRefund/selectRefundTenantPage", r)
    },
    selectRefundCompanyPage(r) {
        return http.get("/gateway/api/sycompany/pc/orderCenterRefund/selectRefundCompanyPage", r)
    },
    selectRefundInfo(r) {
        return http.get("/gateway/api/sycompany/pc/orderCenterRefund/selectRefundInfo", r)
    },
    getCompanyOrderCount(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterPC/getCompanyOrderCount", r)
    },
    confirmVerificationSp(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/OrderCenterPC/confirmVerificationSp", r)
    },
    changePickup(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/OrderCenterPC/changePickup", r)
    },
    selectOrderStatisticsTenantPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAmountDaily/selectTenantPage", r)
    },
    queryByRecordPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyReceiptApi/queryByRecordPage", r)
    },
    printOrder(r) {
        return http.confirm.get("/gateway/api/sycompany/pc/OrderCenterPC/printOrder", r)
    },
    cashPay(scene,r) {
        return http.payload(`/gateway/api/sycompany/pc/CompanyOrderPayCenterPC/${scene}/cashPay`, r)
    },
    createRefund(r) {
        return http.payload(`/gateway/api/sycompany/pc/CompanyOrderPayCenterPC/createRefund`, r)
    },
    checkRefund(r) {
        return http.payload(`/gateway/api/sycompany/pc/CompanyOrderPayCenterPC/checkRefund`, r)
    },
    agreeRefund(r) {
        return http.payload(`/gateway/api/sycompany/pc/CompanyOrderPayCenterPC/agreeRefund`, r)
    },
    cancelRefund(r) {
        return http.payload(`/gateway/api/sycompany/pc/CompanyOrderPayCenterPC/cancelRefund`, r)
    },
    getBill(r) {
        return http.get(`/gateway/api/sycompany/pc/OrderCenterBillPC/getBill`, r)
    },
    generateBill(r) {
        return http.get(`/gateway/api/sycompany/pc/OrderCenterBillPC/generate`, r)
    },
    exportCompanyOrder(r) {
        return http.spin.get(`/gateway/api/sycompany/pc/OrderCenterPC/exportCompanyOrder`, r)
    },
    exportCompanyOrder2(r) {
        return http.spin.get(`/gateway/api/sycompany/pc/OrderCenterPC/exportCompanyOrder2`, r)
    },
    orderLogisticsEdit(r) {
        return http.spin.payload(`/gateway/api/sycompany/pc/OrderCenterPC/orderLogisticsEdit`, r)
    },
    logisticsBatch(r) {
        return http.spin.postFile(`/gateway/upload/sycompany/pc/orderCenter/logisticsBatch`, r)
    },
    queryCompanyBillData(r) {
        return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillPC/queryCompanyBillData", r)
    },
    selectByGoodsCompanyView(r) {
        return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillPC/selectByGoodsCompanyView", r)
    },
    /** 运营商：收银员日销售矩阵（实时） */
    queryCashierSalesDailyMatrix(r) {
        return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillPC/queryCashierSalesDailyMatrix", r)
    },
    /** 运营商：收银员日订单明细（实时） */
    queryCashierSalesDailyDetail(r) {
        return http.get("/gateway/api/sycompany/pc/OrderCenterBillPC/queryCashierSalesDailyDetail", r)
    },
    completeLogistics(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/OrderCenterPC/completeLogistics", r)
    },
    exportOrderCenterForm(r) {
        return http.spin.post("/gateway/api/sycompany/pc/orderCenterForm/exportOrderCenterForm", r)
    },
}
export default orderCenter
